import React, {useEffect, useState} from "react";
import {getAuth, updatePassword} from "@firebase/auth";
import {Col, Form} from "react-bootstrap";
import {doc, setDoc} from "@firebase/firestore";
import {db} from "../../firebase/FirebaseProvider";
import {CurrentUser} from "../../types/Types";
import AuthCheck from "../../components/auth/AuthCheck";

interface Props {
    currentUser: CurrentUser;
}

function SettingsPage(props: Props) {
    const [password, setPassword] = useState<string>("");
    const [name, setName] = useState<string>("");
    const [feedback, setFeedback] = useState<string>("");
    const [error, setError] = useState<boolean>(false);

    useEffect(() => {
        if(!props.currentUser.hasSetPassword) {
            setFeedback("It looks like you haven't set your name or password yet, please set them below.")
        }
    }, [props.currentUser]);

    const saveDetails = async () => {
        if(password.length < 6) {
            setError(true);
            setFeedback("Your password must contain 6 or more characters.")
        }
        if(password.length < 2) {
            setError(true);
            setFeedback("Your name must contain 2 or more characters.")
        }
        const auth = getAuth();
        const user = auth.currentUser;
        if(user && password) {
            updatePassword(user, password).then(() => {
                setError(false);
                setFeedback("Details successfully saved.");
                updateUser();
            }).catch((error) => {
                setError(true);
                if(error.message.includes("requires-recent-login")) {
                    setFeedback("To set a password you need to have logged in more recently, please log out and log back in, and then try again.");
                } else {
                    setFeedback(error.message);
                }
            });
        }
    };

    async function updateUser(): Promise<void> {
        const docRef = doc(db, 'users', props.currentUser.id);
        try {
            const data = {
                name: name,
                hasSetPassword: true,
            };
            await setDoc(docRef, data, { merge: true });
        } catch (error) {
            console.error("Error: ", error);
        }
    }

    return (
        <>
            <AuthCheck />
            <div>
                {feedback && <div className={`basic-box mb-2 ${error ? "alert-danger" : "alert-success"}`}>
                    <div>{feedback}</div>
                </div>}
                <Form>
                    <div className="form-row">
                        <Col>
                            <Form.Group className="form-element" controlId="password">
                                <Form.Label>
                                    <small>
                                        <b>Name</b>
                                    </small></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name={"name"}
                                        placeholder=""
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        required
                                    />
                            </Form.Group>
                        </Col>
                    </div>
                    <div className="form-row">
                        <Col>
                            <Form.Group className="form-element" controlId="password">
                                <Form.Label>
                                    <small>
                                        <b>Password</b>
                                    </small></Form.Label>
                                    <Form.Control
                                        type="password"
                                        name={"password"}
                                        placeholder=""
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                            </Form.Group>
                        </Col>
                    </div>
                    <div className={"primary-button mt-3"} onClick={() => saveDetails()}>
                        <span>Save Details</span>
                    </div>
                </Form>
            </div>
        </>
    );
};

export default SettingsPage;
